const DEFAULT_COLORS = ["#1E22FF", "#6366FF", "#9194FF", "#AEB0FF", "#D2D3FF"];
const CHANNEL_SELECTED_COLORS = ["#95959D", "#95959dd1", "#95959da8", "#95959d96", "#95959d6e"];
const CHANNEL_SELECTED_BIGGER_COLOR = "#1E22FF";
const TARGET_VALUE = "#36F99F";

export const selectColorPalette = (index, metric, selectedChannel) => {
  const isMetricChannelSelected = metric.name === selectedChannel;
  const showTargetValue = metric.value >= 1 && (!selectedChannel || isMetricChannelSelected);

  if (showTargetValue) return TARGET_VALUE;
  if (!selectedChannel) return DEFAULT_COLORS[index % DEFAULT_COLORS.length];
  if (isMetricChannelSelected) return CHANNEL_SELECTED_BIGGER_COLOR;

  return CHANNEL_SELECTED_COLORS[index % DEFAULT_COLORS.length];
};
